import React, { useRef, useEffect } from "react";
import classes from "./Banner.module.css";
import Container from "../../UI/Container/Container";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Banner = (props) => {
  const bannerRef = useRef(0);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: bannerRef.current,
        start: "top 50%",
      },
    });

    timeline.to(bannerRef.current, {
      opacity: 1,
      duration: 0.5,
      ease: "sine.out",
    });
  });

  return (
    <div className={classes.Banner}>
      <Container>
        <h2 ref={bannerRef}>DICKINSON DOESN'T SIT IN THE MIDDLE OF NOWHERE.</h2>
      </Container>
    </div>
  );
};

export default Banner;
